// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const MyAccountStyles = css`
  margin-bottom: ${(props) => props.theme.spacing.LAYOUT_SPACING.SM};
  .is-visible-nav {
    display: none;
  }
  .is-hidden-nav {
    display: block;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
  }
  .no-outline {
    margin: 14px;
    &:focus,
    &:active {
      outline: 0;
    }
  }
  .account-dashboard-outline {
    margin: 0;
  }
  .user-welcome {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    overflow-wrap: break-word;
  }
  .is-guest-fav {
    overflow-wrap: unset;
    padding-left: ${({ theme }) => theme.spacing.ELEM_SPACING.LRG};
    padding-bottom: ${({ theme }) => theme.spacing.ELEM_SPACING.XS};
    font-size: ${({ theme }) => theme.fonts.fontSize.body.bodytext.copy8}px;
    font-weight: normal;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .is-hidden-nav {
      display: none;
    }
    .is-visible-nav {
      display: flex;

      flex-direction: column;
      margin-right: 0;
      width: 340px;
      border-right: 1px solid #d9d9d9;
    }
    ${(props) =>
      `
      .account-main{
        background: ${props.theme.colorPalette.gray[3400]};
        width: 76.3%;
        @media ${props.theme.mediaQuery.large}{
          width: calc(100% - 424px);
        }
        padding: 0px ${props.theme.spacing.ELEM_SPACING.XXL} ${props.theme.spacing.ELEM_SPACING.XXXL};
      }
      .bg-white {
        background: ${props.theme.colors.WHITE};
      }
      `}
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${(props) =>
      props.isPlacePerkEnabled
        ? `.show-account-header-in-mobile {
            display: block;
            ul {
              display: none;
            }
            .rewards-point {
              border: none;
            }
          }`
        : ''}
  }
  .place-perks-dashboard-outline {
    margin: 0;
  }
`;

export default MyAccountStyles;
